import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import App from './App.vue'
import router from './router'
import store from './store'
import utils from './utils'
import Vant from 'vant'
import getInterface from '@/assets/js/interface.js'
import {postRequest} from './assets/js/httpInterface'
import {postRequestJson} from './assets/js/httpInterface'
import {getRequest} from './assets/js/httpInterface'
import {uploadFileRequest} from './assets/js/httpInterface'
import 'vant/lib/index.css';

Vue.prototype.getRequest = getRequest;
Vue.prototype.postRequest = postRequest;
Vue.prototype.postRequestJson = postRequestJson;
Vue.prototype.uploadFileRequest = uploadFileRequest;

Vue.prototype.$utils=utils

Vue.use(Vant);
Vue.use(getInterface)
Vue.use(VueAxios, axios);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
